import { render } from "./agentslist.vue?vue&type=template&id=59e5dd97"
import script from "./agentslist.vue?vue&type=script&lang=js"
export * from "./agentslist.vue?vue&type=script&lang=js"

import "./agentslist.vue?vue&type=style&index=0&id=59e5dd97&lang=css"
import "./agentslist.vue?vue&type=style&index=1&id=59e5dd97&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__